import React, { useState, useEffect } from 'react';
import { X, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { trackCTA } from '../utils/analytics';

const StickyCTA = ({ onOpenPopup }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      if (window.scrollY > 300 && !isDismissed) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleDismiss = () => {
    setIsDismissed(true);
    setIsVisible(false);
  };

  const handleClick = () => {
    trackCTA('Request Demo', 'sticky_cta');
    onOpenPopup();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 animate-in slide-in-from-bottom-4 duration-500">
      <div className="relative">
        {/* Dismiss button */}
        <button
          onClick={handleDismiss}
          className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-lg hover:bg-gray-100 transition-colors z-10"
          aria-label="Dismiss"
        >
          <X size={16} className="text-gray-600" />
        </button>

        {/* CTA Button */}
        <Button
          onClick={handleClick}
          className="bg-[#FF7A00] hover:bg-[#e66d00] text-white font-semibold px-6 py-4 rounded-full shadow-2xl hover:scale-105 transition-all duration-200 flex items-center space-x-2 group"
        >
          <MessageCircle size={20} className="group-hover:rotate-12 transition-transform" />
          <span>Request Demo</span>
        </Button>
      </div>
    </div>
  );
};

export default StickyCTA;